import {
	Typography,
	Box,
	TextField,
	Button,
} from '@mui/material';
import { connect } from 'react-redux';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { BOOKING_INTERLOCK_OVERRIDE } from '../../constants';

const mapStateToProps = (state) => ({
	themeMode: state.theme.themeMode,
});

const ExceptionModal = ({ themeMode, open, handleClose, handleSubmit }) => {
	const navigate = useNavigate();
	const isDark = themeMode === 'dark';

	const colors = {
		bgOuter: isDark ? '#2B2B2B' : '#F2F2F2',
		bgInner: isDark
			? 'linear-gradient(115.48deg, #2F2F2F 31.9%, #3A3A3A 99.99%)'
			: 'linear-gradient(115.48deg, #DFDFDF 31.9%, #F1F1F1 99.99%)',
		label: isDark ? '#E0E0E0' : '#202020',
		value: isDark ? '#FFFFFF' : '#202020',
		inputBg: isDark ? '#3A3A3A' : '#F8F8F8',
		border: isDark ? '#a7a7a7ff' : '#231F20',
		selectColor: isDark ? '#EAEAEA' : '#231F20',
		buttonGradient: 'linear-gradient(90deg, #231F20 0%, #000000 100%)',
		buttonText: '#FFFFFF',
	};

	const [userData, setUserData] = useState({
		username: '',
		password: '',
		action: BOOKING_INTERLOCK_OVERRIDE,
		remark: '',
	});

	const handleChange = (field) => (e) => {
		setUserData({ ...userData, [field]: e.target.value });
	};

	return (
		<ModalDialog open={open} title="Exception" onClose={handleClose}>
			<Box
				sx={{
					width: '60%',
					display: 'flex',
					flexDirection: 'column',
					gap: 3,
					boxSizing: 'border-box',
				}}
			>
				{/* Username */}
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
					<Typography
						sx={{
							fontFamily: 'JLR Emeric, sans-serif',
							fontWeight: 400,
							fontSize: '20px',
							color: colors.label,
						}}
					>
						User Name
					</Typography>
					<TextField
						fullWidth
						variant="outlined"
						value={userData.username}
						onChange={handleChange('username')}
						placeholder="Enter username"
						InputProps={{
							sx: {
								background: colors.inputBg,
								color: colors.value,
								borderRadius: '8px',
								'& fieldset': {
									borderColor: colors.border,
								},
							},
						}}
					/>
				</Box>

				{/* Password */}
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
					<Typography
						sx={{
							fontFamily: 'JLR Emeric, sans-serif',
							fontWeight: 400,
							fontSize: '20px',
							color: colors.label,
						}}
					>
						Password
					</Typography>
					<TextField
						fullWidth
						variant="outlined"
						type="password"
						value={userData.password}
						onChange={handleChange('password')}
						placeholder="Enter password"
						InputProps={{
							sx: {
								background: colors.inputBg,
								color: colors.value,
								borderRadius: '8px',
								'& fieldset': {
									borderColor: colors.border,
								},
							},
						}}
					/>
				</Box>

				{/* Confirm Button */}
				<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
					<Button
						variant="contained"
						disableElevation
						sx={{
							width: 200,
							height: 40,
							borderRadius: '16px',
							textTransform: 'none',
							fontFamily: 'JLR Emeric, sans-serif',
							fontWeight: 600,
							fontSize: '24px',
							background: colors.buttonGradient,
							color: colors.buttonText,
							'&:hover': {
								opacity: 0.9,
								background: colors.buttonGradient,
							},
						}}
						onClick={() => handleSubmit(userData)}
					>
						Confirm
					</Button>
				</Box>
			</Box>
		</ModalDialog>
	);
};

export default connect(mapStateToProps)(ExceptionModal);
